import {
  addMessage,
  getMessages,
  getOneMessage,
  updateMessage,
} from "@/services/endpoints/message";

export default {
  async addMessage({ commit }, payload) {
    try {
      let res = await addMessage(payload);
      if (res) {
        return res.data;
      } else {
        throw new Error("err");
      }
    } catch (err) {
      throw new Error(err);
    }
  },
  async getOneMessage({ commit }, payload) {
    try {
      let res = await getOneMessage(payload);
      if (res) {
        return res.data;
      } else {
        throw new Error("err");
      }
    } catch (err) {
      throw new Error(err);
    }
  },
  async updateMessage({ commit }, payload) {
    try {
      let res = await updateMessage(payload.id, payload.payload);
      if (res) {
        return res.data;
      } else {
        throw new Error("err");
      }
    } catch (err) {
      throw new Error(err);
    }
  },
  async getMessages({ commit }, payload) {
    try {
      let res = await getMessages(payload);
      if (res) {
        return res.data;
      }
    } catch (err) {
      throw new Error(err);
    }
  },
};
